var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select',{attrs:{"options":_vm.countries,"v":_vm.v,"value":_vm.value,"help":_vm.help,"shortTitle":_vm.shortTitle,"simple":"","label":_vm.$t('Land')},on:{"input":value => _vm.$emit('input', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }